module.exports = __webpack_public_path__ + "img/Jim Ziegler.b82a004c.jpg";